import posthog from "posthog-js";

export const analytics = {
  track: (event, properties) => {
    posthog.capture(event, properties);
  }
}
